import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-native-fontawesome"
import React, { FC } from "react"
import { StyleSheet, View } from "react-native"

interface IconCircleSizedProps {
  icon: IconProp
  size: number
  width: number
}

const IconCircleSized: FC<IconCircleSizedProps> = (props) => (
  <View
    style={[
      styles.circle,
      { borderRadius: props.width / 2, height: props.width, width: props.width },
    ]}
  >
    <FontAwesomeIcon size={props.size} icon={props.icon} style={styles.icon} />
  </View>
)

// Styles
const styles = StyleSheet.create({
  circle: {
    backgroundColor: "rgba(248, 255, 255, 0.15)",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    color: "white",
  },
})

export default IconCircleSized
